// ═══════════════════════════════════════════════════════════════════
//  La rueda del ratón NO cambia los campos numéricos (entrega 326)
//
//  Manuel: «en todos los campos como ese (Nº de coches), si le dan a la rueda
//  del ratón estando dentro se les desplaza… quiero que no sea así para
//  evitar errores». Es lo que hace el navegador con <input type="number">:
//  con el cursor dentro, cada vuelta de rueda sube o baja el valor. Se va a
//  bajar la página, se gira la rueda y el 12 se queda en 9 sin que nadie se
//  dé cuenta.
//
//  Arreglo para TODA la aplicación, en un solo sitio (no campo a campo): al
//  girar la rueda encima de un campo numérico que tiene el cursor, el campo
//  suelta el cursor ANTES de que el navegador cambie el número. Así la rueda
//  hace lo que se espera, bajar la página, y el valor no se toca. Para
//  cambiarlo se sigue pudiendo escribir o usar las flechitas del campo.
// ═══════════════════════════════════════════════════════════════════
export function alGirarRueda(e) {
  const el = e.target;
  if (el && el.tagName === 'INPUT' && el.type === 'number'
      && el.ownerDocument && el.ownerDocument.activeElement === el) {
    el.blur();
  }
}

// Se escucha en la fase de CAPTURA y sin `passive:false`: no hace falta
// cancelar nada (la página tiene que seguir bajando), solo soltar el cursor
// antes de que el campo reciba la rueda.
export function instalarSinRueda(doc = document) {
  doc.addEventListener('wheel', alGirarRueda, { capture: true, passive: true });
  return () => doc.removeEventListener('wheel', alGirarRueda, { capture: true });
}
